// @ts-check
import {
  SET_NOT_SIGNED_IN,
  SET_SIGNED_IN,
  SET_USER_DATA,
  SET_USER_IS_REGISTERED
} from '../../redux/actions/actionTypes';

const initialState = {
  isUserRegistered: false,
  user: null,
  userData: {
    profession: null,
    professionFreeText: null,
    industry: null,
    industryFreeText: null,
    companyEmployeesNum: null,
    futureWorkSuggestion: null,
    email: null
  },
  providerId: ''
}

// formCostsReducer
export const authReducer = (state = initialState, action) => {
  switch (action.type) {
    ////// probably not needed
    // case SET_NOT_SIGNED_IN:
    //   return {
    //     ...state,
    //     isUserRegistered: false,
    //     user: action.payload.user,
    //     providerId: action.payload.providerId
    //   }

    case SET_SIGNED_IN:
      return {
        ...state,
        user: action.payload.user,
        providerId: action.payload.providerId
      }

    case SET_USER_DATA:
      return {
        ...state,
        userData: {
          ...state.userData,
          [action.payload.field]: action.payload.value
        }
      }

    case SET_USER_IS_REGISTERED:
      return {
        ...state,
        isUserRegistered: action.payload
      }

    default:
      return state;
  }
}
